import {
	blackListFallWinterOffset,
	blackListNews,
	blackListSpringSummer,
	blackListSummit,
} from '@lc/const/blacklist';
import { decisionTurnOrder } from '@lc/const/turnTypes';
import { GameState } from '@lc/interface/gameState/types';
import { colors, energyColors } from '@lc/types/Misc';

import { getRandomArrayIndex } from './array';

export function coinFlip(chance = 0.5): boolean {
	if (chance === 0) {
		return false;
	}
	console.log('chance ' + chance);
	return Math.random() < chance;
}

export function createDecks() {
	const decks = [
		createShuffledIntArray(69), // spring summer
		createShuffledIntArray(69, 100), // fall winter
		createShuffledIntArray(39), // news
		createShuffledIntArray(19), // summit
	];

	filterDecks(decks);

	return decks;
}

function createShuffledIntArray(n: number, offset: number = 0) {
	const intArray = [offset];

	for (let i = 1; i <= n; i++) {
		intArray.push(i + offset);
	}

	shuffleArray(intArray);

	return intArray;
}

function filterDecks(decks: number[][]) {
	removeCardsOnBlacklist(decks[0], blackListSpringSummer);
	removeCardsOnBlacklist(decks[1], blackListFallWinterOffset);
	removeCardsOnBlacklist(decks[2], blackListNews);
	removeCardsOnBlacklist(decks[3], blackListSummit);
}

export function getCurrentSeasonDeck(gameState: GameState) {
	if (gameState.seasonTracker < 2) {
		return gameState.DeckSS;
	} else {
		return gameState.DeckFW;
	}
}

export function getEnergyColorFromColor(color: colors): energyColors {
	switch (color) {
		case 'red':
			return 'r';
		case 'blue':
			return 'b';
		case 'green':
			return 'g';
		case 'yellow':
			return 'y';
	}
	console.log('ERROR, COLOR NOT FOUND ' + color);
}

async function getPlayerIdForTurnOrderDecision(gameState: GameState) {
	const players = gameState.playerStateArray;
	let playerIds: number[] = [];
	let maxPR = 0;
	// Player with highest PR
	for (const p of players) {
		if (p.prArr.length > maxPR) {
			maxPR = p.prArr.length;
			playerIds = [p.playerId];
		} else if (p.prArr.length === maxPR) {
			playerIds.push(p.playerId);
		}
	}

	if (playerIds.length === 1) {
		return playerIds[0];
	}

	// Else If, Player with highest factories
	let maxFactories = 0;

	for (const p of players) {
		if (!playerIds.includes(p.playerId)) {
			continue;
		}
		if (p.factories > maxFactories) {
			maxFactories = p.factories;
			playerIds = [p.playerId];
		} else if (p.factories === maxFactories) {
			playerIds.push(p.playerId);
		}
	}

	if (playerIds.length === 1) {
		return playerIds[0];
	}

	// Else If, Player with highest batteries
	let maxBatteries = 0;

	for (const p of players) {
		if (!playerIds.includes(p.playerId)) {
			continue;
		}
		if (p.batteries > maxBatteries) {
			maxBatteries = p.batteries;
			playerIds = [p.playerId];
		} else if (p.batteries === maxBatteries) {
			playerIds.push(p.playerId);
		}
	}

	if (playerIds.length === 1) {
		return playerIds[0];
	}

	// Else, Random Player
	const randomIndex = getRandomArrayIndex(playerIds);
	return playerIds[randomIndex];
}

export function isContractDue(currCard: any, gameState: GameState) {
	const dueDate = currCard.due;

	if (dueDate === 'next') {
		return true;
	} else if (dueDate === 'spring' && gameState.seasonTracker === 0) {
		return true;
	} else if (dueDate === 'summer' && gameState.seasonTracker === 1) {
		return true;
	} else if (dueDate === 'fall' && gameState.seasonTracker === 2) {
		return true;
	} else if (dueDate === 'winter' && gameState.seasonTracker === 3) {
		return true;
	}

	return false;
}

/**
 * Sets turnType to turnOrderDecision
 * Sets activePlayerId to player who is making decision
 * @param gameState
 */
export async function setStateForPRTurnDecision(
	gameState: GameState,
	ticker: string[]
) {
	console.log('setStateForPRTurnDecision');
	// begin by setting turnType for how gameState is altered for next entity to respond (entity = player or ai)
	gameState.turnType = decisionTurnOrder;
	gameState.activePlayerId = await getPlayerIdForTurnOrderDecision(gameState);

	ticker.unshift(`Player ${gameState.activePlayerId} is deciding turn order`);
}

async function removeCardsOnBlacklist(deck: number[], blackList: number[]) {
	if (blackList == null || blackList.length === 0) {
		deck = [];
	}
	for (let i = deck.length - 1; i >= 0; i--) {
		for (const cardNum of blackList) {
			if (deck[i] === cardNum) {
				deck.splice(i, 1);
				break;
			}
		}
	}
}

export function shuffleArray(array: number[]) {
	for (let i = array.length - 1; i >= 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
}

export function createTurnOrderArray(length: number) {
	const turnOrder = [0, 1, 2];
	if (length > 3) {
		turnOrder.push(3);
	}
	// shuffleArray(turnOrder);

	return turnOrder;
}

export async function shufflePlayerOrder(players: any[], turnOrder: number[]) {
	const shuffledTurnOrder = [...turnOrder];
	shuffleArray(shuffledTurnOrder);
	for (let i = 0; i < players.length; i++) {
		players[i].player_id = shuffledTurnOrder[i];
	}

	players.sort((a, b) => a.player_id - b.player_id);
}
